class SpecTransportsDataStore {
    constructor (apiRoot) {
        this.apiRoot = apiRoot
    }

    loadSpecTransportsForPortal() {
        return fetch(`${this.apiRoot}/getVehicles.php?`)
        .then((data) => data.json())
        .then((data) => {
            if (data.r === "ok") {
                return data.data;
            } else {
                throw new Error("request fail");
            }
        })
        .catch((error) => {
            let errorMessage = error.message.trim();
            // alert(errorMessage)
            return []
        });
    }
}

export default SpecTransportsDataStore;
